/**
 *一些公用的方法省得每次都去写
 */
const roles = {
  /**
   * 总代 GAGE
   */
  "1":"GAGE",
  /**
   * 代理 AGE
   */
  "2":"AGE",
  /**
   * 子代理 SUB_AGE
   */
  "3":"SUB_AGE",
  /**
   * 企业
   */
  "4":"ENT",
  /**
   * 管理
   */
  "5":"GAGE_MGT",
  /**
   * 查询
   */
  "6":"GAGE_QRY",
  /**
   * 终端用户
   */
  "7":"TERMINAL",
  /**
   * 代理
   */
  "8":"AGE_QRY",
  /**
   * 管理
   */
  "9":"AGE_MGT",
  /**
   * 查询
   */
  "10":"SUB_AGE_QRY",
  /**
   * 管理
   */
  "11":"SUB_AGE_MGT",
  /**
   * 查询
   */
  "12":"ENT_QRY",
  /**
   * 管理
   */
  "13":"ENT_MGT",
  /**
   * 二级企业
   */
  "14":"SUB_ENT",
  /**
   * 查询
   */
  "15":"SUB_ENT_QRY",
  /**
   * 会计
   */
  "16":"ACCT",
};

//有些角色只能看到父亲的内容
export const queryUserId = (role, id, patentId) => {
  if(!role){
    return id;
  }
  if (isMGTorQry(role)) {
    return patentId;
  }
  return id;
};

export const isMGT = (val) =>{
  //console.log("isMGT role:" + val + ",temp:"+roles[val]);
  let temp = roles[val];
  return (temp.indexOf("MGT") != -1);
  return false;
}

/**
 * 是否是信息查询角色
 *
 * @param val
 * @return
 */
export const isQRY = (val) =>{
  //console.log("isQRY role:" + val + ",temp:"+roles[val]);
  let temp = roles[val];
  return (temp.indexOf("QRY") != -1);
  return false;
}

export const isMGTorQry = (val) => {
  let temp = roles[val];
  if(temp && (isMGT(val) || isQRY(val))){
    return true;
  }
  return false;
}

export const queryRole = str => {
  let role = undefined;
  switch (str+"") {
    case "1":
    case "5":
    case "6":
      role = 1;
      break;
    case "2":
    case "8":
    case "9":
      role = 2;
      break;
    case "3":
    case "10":
    case "11":
      role = 3;
      break;
    case "4":
    case "12":
    case "13":
      role = 4;
      break;
    case "14":
      role = 14;
      break;
    default:
      break;
  }
  return role;
};


  const  betweenOfDay = (dateString1,dateString2)=>{
  let  startDate = Date.parse(dateString1);
  let  endDate = Date.parse(dateString2);
  return   (endDate - startDate)/(24*60*60*1000);
};

 const betweenDay = (dateString1) =>{
   let  startDate =   new Date();
   let  endDate = Date.parse(dateString1);
   return   (endDate - startDate)/(24*60*60*1000);
};



export default {
  queryRole,
  queryUserId,
  isMGT,
  isQRY,
  betweenOfDay,
  betweenDay,
  isMGTorQry
}



// WEBPACK FOOTER //
// ./src/lib/CommonUtils.js